export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_MANUFACTURERS':
      return { ...state, manufacturers: action.manufacturers };
    case 'GET_MANUFACTURER':
      return { ...state, manufacturer: action.manufacturer };
    default:
      return state;
  }
};
